import { createServiceFactory } from '@/services/factory'
import { createHttpClientPortalService } from './clientPortal.http'
import { createMockClientPortalService } from './clientPortal.mock'

export type { ClientPortalService } from './clientPortal.service'

export const getClientPortalService = createServiceFactory(
  'customers',
  createMockClientPortalService,
  createHttpClientPortalService,
)

